import { ReactNode } from 'react';

import WebpImage from '@r1-frontend/ui-react/components/WebpImage';

import Widget from '~/src/components/Widget';

import * as ST from './styled';

interface IStubImage {
    url: string,
    urlWebp: string,
    alt: string,
}

const defaultImageData: IStubImage = {
    url: '/static/images/lk/stub-eyes.png',
    urlWebp: '/static/images/lk/stub-eyes.webp',
    alt: 'Изображение глаз',
};

interface IStubProps {
    title: string,
    description: string | ReactNode,
    imageData?: IStubImage,
    children?: ReactNode,
}

const StubNoData = ({
    title,
    description,
    imageData = defaultImageData,
    children = <></>,
}: IStubProps): JSX.Element => {
    const { url, urlWebp, alt } = imageData;

    return (
        <Widget>
            <ST.ImageBlock>
                <WebpImage urlWebp={urlWebp}>
                    <Widget.Image src={url} alt={alt}/>
                </WebpImage>
            </ST.ImageBlock>
            <Widget.ContentBlock>
                <Widget.Name>{title}</Widget.Name>
                <Widget.Description>{description}</Widget.Description>
                {children}
            </Widget.ContentBlock>
        </Widget>
    );
};

export default StubNoData;
